import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=ba6f69e8&scoped=true"
import script from "./ContentList.vue?vue&type=script&lang=js"
export * from "./ContentList.vue?vue&type=script&lang=js"
import style0 from "./ContentList.vue?vue&type=style&index=0&id=ba6f69e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6f69e8",
  null
  
)

export default component.exports